import { render, staticRenderFns } from "./ModalInformation.vue?vue&type=template&id=25704280&"
import script from "./ModalInformation.vue?vue&type=script&lang=js&"
export * from "./ModalInformation.vue?vue&type=script&lang=js&"
import style0 from "./ModalInformation.vue?vue&type=style&index=0&id=25704280&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports